
import { WorkoutForm } from "@/components/workouts/WorkoutForm";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useMobileMenu } from "@/components/dashboard/header/useMobileMenu";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";

const NewWorkout = () => {
  const navigate = useNavigate();
  const { closeMenu } = useMobileMenu();
  const { t } = useTranslations("workouts");
  const { getPath } = useLanguagePath();
  
  const handleBack = () => {
    closeMenu();
    navigate(getPath("/dashboard/workouts"));
  };
  
  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight gradient-text text-slate-950 dark:text-white">{t("newWorkout.title")}</h2>
          <p className="text-muted-foreground dark:text-gray-300">
            {t("newWorkout.subtitle")}
          </p>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80 dark:text-flame dark:hover:text-flame/80">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/dashboard/workouts")} className="text-flame hover:text-flame/80 dark:text-flame dark:hover:text-flame/80">{t("title")}</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium dark:text-white">{t("newWorkout.title")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <Button variant="outline" onClick={handleBack} className="mt-2 md:mt-0 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700">
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t("actions.back")}
        </Button>
      </div>

      <div className="bg-transparent">
        <WorkoutForm />
      </div>
    </div>
  );
};

export default NewWorkout;
